import { useState, useEffect, useRef } from 'react';
import { ErrorToastContainer } from '../../function/CustomFunction';

export default function BuyCreditsModal({ open, onClose, setvisible,setBilininformation,bilininformation}) {
  const [show, setShow] = useState(open);
  const [animateState, setAnimateState] = useState('closed');
  const modalRef = useRef(null);

  useEffect(() => {
    if (open) {
      setShow(true);
      setAnimateState('opening');
      setTimeout(() => setAnimateState('open'), 10);
    } else if (show) {
      setAnimateState('closing');
      const timeout = setTimeout(() => {
        setShow(false);
        setAnimateState('closed');
      }, 350);
      return () => clearTimeout(timeout);
    }
  }, [open]);

  if (!show && animateState === 'closed') return null;

  // Animation logic
  let transform = 'translateX(60px)';
  let opacity = 0;
  if (animateState === 'opening') {
    transform = 'translateX(60px)';
    opacity = 0;
  } else if (animateState === 'open') {
    transform = 'translateX(0)';
    opacity = 1;
  } else if (animateState === 'closing') {
    transform = 'translateX(60px)';
    opacity = 0;
  }

  // Handle purchase click
  const handlePurchase = async () => {
    // if (!hasPermission(PERMISSIONS.DASHBOARD_PURCHASE_CREDIT)) {
    //   ErrorToastContainer('You do not have permission to purchase credits');
    //   return;
    // }

    if (bilininformation.amount < 1000) {
      ErrorToastContainer('Minimum purchase of ₹1000 credits is allowed');
      onClose();
      return;
    }
    onClose();
    setvisible(true);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.25)',
          opacity: animateState === 'open' ? 1 : 0,
          transition: 'opacity 0.35s cubic-bezier(0.4,0,0.2,1)',
          zIndex: 1999,
          pointerEvents: open ? 'auto' : 'none',
        }}
      />
      {/* Modal */}
      <div
        ref={modalRef}
        className="buy-credits-modal"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: 420,
          height: '100vh',
          background: '#fff',
          boxShadow: '-2px 0 16px rgba(60,72,88,0.10)',
          zIndex: 2000,
          transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.35s cubic-bezier(0.4,0,0.2,1)',
          transform,
          opacity,
          display: 'flex',
          flexDirection: 'column',
          padding: '32px 28px',
          overflowY: 'auto',
        }}
      >
        <div className="buy-credits-modal-heading" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
          <div style={{ fontWeight: 700, fontSize: 22 }}>Purchase Message Credits</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 26, cursor: 'pointer', color: '#888' }}>×</button>
        </div>
        <div className="buy-credits-modal-desc" style={{ color: '#444', fontSize: 15, marginBottom: 18 }}>
          These ad credits can be used to create and run ads directly from our CRM's Ad Manager. Ads will be shown on Facebook, Instagram, and direct users to WhatsApp.
        </div>
        <div className="buy-credits-modal-box" style={{ background: '#f4fafd', borderRadius: 10, padding: '22px 18px', marginBottom: 18 }}>
          <div className="buy-credits-modal-label" style={{ fontWeight: 600, fontSize: 17, marginBottom: 6 }}>Enter Amount</div>
          <div className="buy-credits-modal-min" style={{ color: '#888', fontSize: 14, marginBottom: 10 }}>Minimum purchase of ₹1000 credits is allowed</div>
          <input
            type="number"
            min={500}
            value={bilininformation.amount}
            onChange={e => setBilininformation(prev => ({
              ...prev,
              amount: e.target.value
            }))}
            style={{
              width: '100%',
              fontSize: 20,
              padding: '10px 12px',
              borderRadius: 6,
              border: '1px solid #b2becd',
              marginBottom: 14,
              outline: 'none',
            }}
          />
          <div style={{ display: 'flex', gap: 10, marginBottom: 0 }}>
            {[1000, 2500,5000].map(val => (
              <button
                key={val}
                className="buy-credits-modal-btn"
                onClick={() => setBilininformation(prev => ({
                  ...prev,
                  amount: val
                }))}
                style={{
                  background: '#fff',
                  border: '1px solid #b2becd',
                  borderRadius: 6,
                  padding: '7px 16px',
                  fontWeight: 600,
                  fontSize: 15,
                  color: '#275c53',
                  cursor: 'pointer',
                }}
              >
                +{val}
              </button>
            ))}
          </div>
        </div>
        <button
          className="buy-credits-modal-purchase"
          style={{
            background: '#43e97b',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '14px 0',
            fontWeight: 700,
            fontSize: 18,
            marginTop: 8,
            cursor: 'pointer',
          }}
          onClick={handlePurchase}
        >
          Purchase Now
        </button>
        <style>{`
          @media (max-width: 700px) {
            .buy-credits-modal {
              width: 95vw !important;
              padding: 18px 8vw !important;
            }
            .buy-credits-modal-heading > div { font-size: 17px !important; }
            .buy-credits-modal-desc { font-size: 12px !important; }
            .buy-credits-modal-label { font-size: 14px !important; }
            .buy-credits-modal-min { font-size: 11px !important; }
            .buy-credits-modal-btn { font-size: 12px !important; padding: 5px 10px !important; }
            .buy-credits-modal-purchase { font-size: 14px !important; padding: 10px 0 !important; }
          }
          @media (max-width: 500px) {
            .buy-credits-modal {
              width: 100vw !important;
              padding: 10px 2vw !important;
            }
            .buy-credits-modal-heading > div { font-size: 14px !important; }
            .buy-credits-modal-desc { font-size: 10px !important; }
            .buy-credits-modal-label { font-size: 11px !important; }
            .buy-credits-modal-min { font-size: 9px !important; }
            .buy-credits-modal-btn { font-size: 10px !important; padding: 3px 6px !important; }
            .buy-credits-modal-purchase { font-size: 12px !important; padding: 8px 0 !important; }
          }
        `}</style>
      </div>
    </>
  );
} 